<ng-container *appI18nScopeReady>
  <div class="project-selection">
    <h1 class="project-selection__title">{{ 'project_selection_title' | i18n }}</h1>

    <div class="project-selection__toolbar">
      <mat-form-field appearance="outline">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            #searchInput
            type="search"
            [(ngModel)]="filterSearch" 
            [placeholder]="('search_input_placeholder' | i18n)"
            (input)="searchQuery.set(searchInput.value)"
          >
      </mat-form-field>

      <div class="project-selection__filters">
        <mat-form-field appearance="outline">
          <mat-label>
            <mat-icon>filter_list</mat-icon>
            {{ 'status_filter_dropdown' | i18n }}
          </mat-label>
          <mat-select [value]="statusFilter()" (selectionChange)="updateStatusFilter($event.value)">
            <mat-option [value]="'All'">{{ 'status.all' | i18n }}</mat-option>
            <mat-option [value]="plantStatusEnum.Online">{{ 'status.online' | i18n }}</mat-option>
            <mat-option [value]="plantStatusEnum.Offline">{{ 'status.offline' | i18n }}</mat-option>
            <mat-option [value]="plantStatusEnum.Inactive">{{ 'status.inactive' | i18n }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>
            <mat-icon>filter_list</mat-icon>
            {{ 'role_filter_dropdown' | i18n}} @if (selectedRoles().length > 0) {<span>({{ selectedRoles().length }})</span>}

          </mat-label>
          <mat-select [value]="selectedRoles()" (selectionChange)="updateRolesFilter($event.value)" multiple>
            @for(role of allRoles(); track role.name) {
              <mat-option [value]="role">{{ role.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

      <button mat-icon-button [matTooltip]="'projects_clear_filters_button' | i18n" (click)="onClearFilters()">
        <mat-icon>filter_list_off</mat-icon>
      </button>

      </div>
    </div>


    <div class="project-selection__table-wrapper">
      @if(projectService.areProjectsCached()) {
      <table class="project-table">
        <thead>
        <tr class="project-table__header-row">
          <th class="project-table__th project-table__th--star">
            <mat-icon class="star-icon">star_border</mat-icon>
          </th>
          <th class="project-table__th">{{ 'table_headers.name' | i18n }}</th>
          <th class="project-table__th project-table__th--center">{{ 'table_headers.status' | i18n }}</th>
          <th class="project-table__th project-table__th--center sort-header" (click)="toggleLastDataSort()" (keydown.enter)="toggleLastDataSort()" tabindex="0">
            {{ 'table_headers.last_data' | i18n }}
            <mat-icon class="sort-icon">{{ lastDataSortAsc() ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
          </th>
          <th class="project-table__th project-table__th--center">{{ 'table_headers.role' | i18n }}</th>
          <th class="project-table__th project-table__th--center">{{ 'table_headers.action' | i18n }}</th>
        </tr>
        </thead>
        <tbody>
          @for (project of filteredProjects(); track project.name) {
            @let isActive = projectService.singlePlantId === project.plantMeta?.id;
            <tr 
              class="project-table__row" 
              [class.project-table__row--clickable]="!isActive"
              (click)="!isActive && openPlant(project)"
              (keydown.enter)="!isActive && openPlant(project)"
            >
              <td class="project-table__td project-table__td--star">
                <button class="star-btn" (click)="toggleFavorite($event, project)">
                  <mat-icon [class.star--active]="project.favorite">
                    {{ project.favorite ? 'star' : 'star_border' }}
                  </mat-icon>
                </button>
              </td>
              <td class="project-table__td project-table__td--name">
                <mat-icon class="plant-icon">factory</mat-icon>
                <span>{{ project.name }}</span>
              </td>
              <td class="project-table__td project-table__td--center">
                @if (project.isHealthLoading) {
                  <span class="project-table__cell-spinner">
                    <mat-spinner [diameter]="18"></mat-spinner>
                  </span>
                } @else if (project.status) {
                  <span class="status-badge"
                    [class.status-badge--online]="project.status === plantStatusEnum.Online"
                    [class.status-badge--offline]="project.status === plantStatusEnum.Offline"
                    [class.status-badge--inactive]="project.status === plantStatusEnum.Inactive"
                  >
                    <span class="status-dot"></span>
                    {{ project.status }}
                  </span>
                } @else {
                  <span>—</span>
                }
              </td>
              <td class="project-table__td project-table__td--center">
                @if (project.isHealthLoading) {
                  <span class="project-table__cell-spinner">
                    <mat-spinner [diameter]="18"></mat-spinner>
                  </span>
                } @else {
                  {{ project.lastData || '—' }}
                }
              </td>
              <td class="project-table__td project-table__td--center">
                <span class="role-pill">{{ project.role }}</span>
              </td>
              <td class="project-table__td project-table__td--center">
                @if (isActive) {
                  <button [disabled]="true" class="open-btn active-btn">Active</button>
                } @else {
                  <button class="open-btn">Open</button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>

      <div class="project-selection__footer">
      <span class="project-selection__count">
        {{ 'table_footer.showing_of_footer' | i18n : {param1: filteredProjects().length, param2: filteredProjects().length} }}
      </span>
        <div class="project-selection__pagination">
          <button class="page-btn" disabled>
            <mat-icon>chevron_left</mat-icon>
          </button>
          <button class="page-btn page-btn--active">1</button>
          <button class="page-btn" disabled>
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </div>
    } @else {
      <div class="spinner-wrapper">
        <app-loading-spinner [loadingText]="i18n.t('loading_projects')"></app-loading-spinner>
      </div>
    }
    </div>
  </div>
</ng-container>
